import { render, staticRenderFns } from "./BeneficiaryContact.vue?vue&type=template&id=1325a446&scoped=true"
import script from "./BeneficiaryContact.vue?vue&type=script&lang=js"
export * from "./BeneficiaryContact.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryContact.vue?vue&type=style&index=0&id=1325a446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1325a446",
  null
  
)

export default component.exports